import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { parse } from '../../../util/urlHelpers';
import { NamedLink } from '../../../components';

import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll, favoritesPage } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = favoritesPage
    ? Object.keys(parse(location.search)).some(key => !['page', 'sort'].includes(key))
    : location.search?.length > 0;
  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <FormattedMessage
        id={
          favoritesPage
            ? hasSearchParams
              ? 'FavoritesPage.noMatchingFavorites'
              : 'FavoritesPage.noFavorites'
            : 'SearchPage.noResults'
        }
      />
      <br />
      {hasSearchParams ? (
        <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
          <FormattedMessage id={'SearchPage.resetAllFilters'} />
        </button>
      ) : null}
      {!favoritesPage && (
        <p>
          <NamedLink className={css.createListingLink} name="NewListingPage">
            <FormattedMessage id="SearchPage.createListing" />
          </NamedLink>
        </p>
      )}
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
